import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { hideLoader, showLoader } from "./loaderSlice";
import endPoints from "../../shared/services/endPoints";
import api from "../../shared/services/api";

export const fetchFAQ = createAsyncThunk(
  "content/fetchTermsOfService",
  async () => {
    const response = await api("get", endPoints.FAQ);
    return response.data;
  }
);

export const fetchOurWork = createAsyncThunk(
  "content/fetchOurWork",
  async (serviceId) => {
    const response = await api("get", endPoints.OUR_WORK + serviceId);
    return response.data;
  }
);

export const fetchOurWorkDetails = createAsyncThunk(
  "content/fetchOurWorkDetails",
  async (id) => {
    const response = await api("get", endPoints.OUR_WORK_DETAILS + id);
    return response.data;
  }
);

export const fetchFrequentQuestions = createAsyncThunk(
  "content/fetchFrequentQuestions",
  async (id) => {
    const response = await api("get", endPoints.FREQUENT_QUESTIONS);
    return response.data;
  }
);

export const fetchOurClients = createAsyncThunk(
  "content/fetchOurClients",
  async (id) => {
    const response = await api("get", endPoints.OUR_CLIENTS);
    return response.data;
  }
);

export const contentSlice = createSlice({
  name: "content",
  initialState: {
    faq: [],
    ourWork: [],
    ourWorkDetails: {},
    frequentQuestions: [],
    ourClients: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      //fetchFAQ
      .addCase(fetchFAQ.pending, (state, action) => {
        state.status = "loading";
        action.asyncDispatch(showLoader());
      })
      .addCase(fetchFAQ.fulfilled, (state, action) => {
        state.status = "succeeded";
        action.asyncDispatch(hideLoader());
        state.faq = action.payload;
      })
      .addCase(fetchFAQ.rejected, (state, action) => {
        state.status = "failed";
        action.asyncDispatch(hideLoader());
        state.error = action.error.message || null;
      })

      //fetchOurWork
      .addCase(fetchOurWork.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchOurWork.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.ourWork = action.payload;
      })
      .addCase(fetchOurWork.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      })

      //fetchOurWorkDetails
      .addCase(fetchOurWorkDetails.pending, (state, action) => {
        state.status = "loading";
        action.asyncDispatch(showLoader());
      })
      .addCase(fetchOurWorkDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        action.asyncDispatch(hideLoader());
        state.ourWorkDetails = action.payload;
      })
      .addCase(fetchOurWorkDetails.rejected, (state, action) => {
        state.status = "failed";
        action.asyncDispatch(hideLoader());
        state.error = action.error.message || null;
      })

      //fetchFrequentQuestions
      .addCase(fetchFrequentQuestions.pending, (state, action) => {
        state.status = "loading";
        action.asyncDispatch(showLoader());
      })
      .addCase(fetchFrequentQuestions.fulfilled, (state, action) => {
        state.status = "succeeded";
        action.asyncDispatch(hideLoader());
        state.frequentQuestions = action.payload;
      })
      .addCase(fetchFrequentQuestions.rejected, (state, action) => {
        state.status = "failed";
        action.asyncDispatch(hideLoader());
        state.error = action.error.message || null;
      })

      //fetchOurClients
      .addCase(fetchOurClients.pending, (state, action) => {
        state.status = "loading";
        action.asyncDispatch(showLoader());
      })
      .addCase(fetchOurClients.fulfilled, (state, action) => {
        state.status = "succeeded";
        action.asyncDispatch(hideLoader());
        state.ourClients = action.payload;
      })
      .addCase(fetchOurClients.rejected, (state, action) => {
        state.status = "failed";
        action.asyncDispatch(hideLoader());
        state.error = action.error.message || null;
      })
  },
});

export default contentSlice.reducer;
